import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, ElementRef, inject, Input } from '@angular/core'

import { ConversationStore } from '@app/modules/messaging/components/store/conversation.store'
import type { Conversation } from '@app/modules/messaging/models/conversation.model'
import type { Message } from '@app/modules/messaging/models/message.model'
import { ConversationUIService } from '@app/modules/messaging/services/conversation-ui.service'
import { Timespan } from '@app/modules/time/core/timespan.enum'
import { UIModule } from '@app/modules/ui/ui.module'

import { VoiceMessagePlayerComponent } from '../voice-message-player/voice-message-player.component'
import { VoiceMessageProgressBarComponent } from '../voice-message-progress-bar/voice-message-progress-bar.component'

@Component({
  selector: 'sb-voice-message',
  templateUrl: './voice-message.component.html',
  styleUrls: ['./voice-message.component.scss'],
  imports: [CommonModule, UIModule, VoiceMessagePlayerComponent, VoiceMessageProgressBarComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VoiceMessageComponent {
  private readonly conversationUIService = inject(ConversationUIService)
  readonly conversationStore = inject(ConversationStore)
  readonly elementRef = inject(ElementRef)
  readonly Timespan = Timespan

  @Input({ required: true }) message!: Message & { type: 'voice' }
  @Input({ required: true }) conversation!: Conversation

  onExpiredVoiceMessageClick(message: Message & { type: 'voice'; status: 'expired' }): void {
    if (!message.is_me) {
      this.conversationUIService.openExpiredVoiceMessageModal(this.elementRef.nativeElement)
    }
  }
}
